import { Navigate } from 'react-router-dom';
import { useEntitlements } from '../../hooks/useEntitlements';
import type { BillingEntitlements } from '../../api/client';

type CapabilityKey = keyof BillingEntitlements['capabilities'];

interface PlanGateProps {
  require: CapabilityKey;
  children: React.ReactNode;
}

export function PlanGate({ require: key, children }: PlanGateProps) {
  const { canUseFeature, isLoading } = useEntitlements();

  // While loading, render nothing — avoids a flash redirect on fast connections
  if (isLoading) return null;

  if (!canUseFeature(key)) {
    return <Navigate to="/profile?tab=billing" replace />;
  }

  return <>{children}</>;
}
